import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

if (typeof Node !== 'undefined' && Node.prototype) {
  const origInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(newChild: T, refChild: Node | null): T {
    if (refChild && refChild.parentNode !== this) {
      return newChild;
    }
    return origInsertBefore.call(this, newChild, refChild) as T;
  };

  const origRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    if (child.parentNode !== this) {
      return child;
    }
    return origRemoveChild.call(this, child) as T;
  };
}

if (typeof DragEvent === 'undefined') {
  (window as any).DragEvent = class DragEvent extends MouseEvent {};
}

if (!Object.fromEntries) {
  (Object.fromEntries as any) = (entries: Iterable<readonly [PropertyKey, unknown]>): Record<string, unknown> => {
    const result: Record<string, unknown> = {};
    for (const [key, value] of entries) {
      result[String(key)] = value;
    }
    return result;
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<App />);
